import React from 'react';
import '../styles/faq.css'; // reuse same FAQ styling

const faqs = [
  {
    question: "What types of videos do you produce?",
    answer: "We create promotional videos, product demos, explainer animations, social media reels, and corporate stories tailored to your brand."
  },
  {
    question: "How can branding help my business?",
    answer: "Strong branding builds trust, recognition, and loyalty. We craft brand identities that connect with your audience across all platforms."
  },
  {
    question: "Is email marketing still effective?",
    answer: "Yes, email remains one of the highest ROI channels. We design campaigns that engage customers, nurture leads, and boost conversions."
  },
  {
    question: "What social media platforms do you manage?",
    answer: "We manage content, ads, and engagement across platforms like Instagram, Facebook, TikTok, LinkedIn, and Twitter/X."
  },
  {
    question: "Do you provide blog writing services?",
    answer: "Absolutely. We write SEO-friendly blog articles that attract visitors, educate customers, and improve search engine rankings."
  },
  {
    question: "Can I combine these services into one package?",
    answer: "Yes, we can create a custom Content & Creative package that includes video, branding, social media, email, and blogging to maximize results."
  }
];

const ContentCreativeFAQs = () => {
  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-grid">
        {faqs.map((item, index) => (
          <div className="faq-item" key={index}>
            <h3 className="faq-question">{item.question}</h3>
            <p className="faq-answer">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ContentCreativeFAQs;
